define(['text!./templates/pa-edit-driver.html', 'underscore', 'edge/platform/util/LocalDateUtil', 'moment'],
    (templateStr, _, LocalDateUtil, moment)=> {
        return ['AgeAllowedToDrive', 'pa.qnb.editableDriverDOB', 'LicensedAgeAllowedToDrive', 'ModalService', (AgeAllowedToDrive, editableDriverDOB, LicensedAgeAllowedToDrive, ModalService)=> {
            return {
                restrict: 'A',
                scope: {
                    driver: '=',
                    prefillVehicles: '=',
                    vehicles: '='
                },
                // added '$rootScope' *Princy
                template: templateStr,
                controller: ['$scope','$rootScope','$filter', 
                'DriverProcessService', ($scope,$rootScope,$filter, DriverProcessService)=> {
                   
                    
                    //SSN INC0019597
                    $scope.ssnMask='999-99-9999';
                    $scope.ssnOriginal=[];
					$scope.isSsnEdit = false;
                    // added scope.age = null along with console.log *Princy
                    $scope.age = null;
                    

                  // console.log( $rootScope) 
                  // addded isPrefilledDriverFlag *Princy UI
                  if($scope.driver.isPrefilledDriver.value== true){
                      $rootScope.isPrefilledDriver = true;
                  }
                  // end of statement-- isPrefilledDriverFlag *Princy

// ctrl.init  added  *Princy
                  
                //   console.log($scope.driver);
                //   console.log($scope.age);



// adding age *Princy UI
                $scope.getAge = function(localDate) {
            
                    var year = parseInt(localDate.year);
                    if(isNaN(year))return '';
                    var month = parseInt(localDate.month) - 1;
                    var day = parseInt(localDate.day);
                    var today = new Date();
                    var birthDate = new Date(year,month,day);
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                    return age ? age: null;
                };
        
            $scope.age= $scope.getAge($scope.driver.dateOfBirth.value);

 // end of statemenet 

            //DFCT0020397 - QnB Date Of Birth Validation -Arpita
            $scope.minDob = "01-01-1800";
            $scope.isMinDateOfBirthValid = true;
            $scope.checkDate = function (){
                if($scope.driver.dateOfBirth.value && $scope.driver.dateOfBirth.value.year && ($scope.driver.dateOfBirth.value.year < "1800")){
                    $scope.isMinDateOfBirthValid = false
                    $scope.driver.dateOfBirth.value = ''
                    return;
                }else{
                    $scope.isMinDateOfBirthValid = true
                }
            }
            //DFCT0020397 - QnB Date Of Birth Validation ends

 $scope.checkExistingSSN = function(elem){
	if ($scope.isSsnEdit) 
	{
        return;
    }
    if($scope.driver.value.ssnunMasked && $scope.driver.value.ssnunMasked.length == 11)
        elem.value = "";
 }
 
 $scope.checkExistingSSNfout = function(elem){
    if($scope.ssnOriginal.join('').length < 9 && $scope.driver.value.ssnunMasked ){
        ssnvalid=$scope.driver.value.ssnunMasked.substring(0,3).replace(/\d/gi,'*') + '-' + $scope.driver.value.ssnunMasked.substring(4,6).replace(/\d/gi,'*') + '-' + $scope.driver.value.ssnunMasked.substring(7,11)
        elem.value = ssnvalid;
    }

 }

 // testing Code *Princy added getAgeFunction

 
//$scope.age= 17;

//end of get age function
 

 $scope.updateSSN =function (elem){

	$scope.isSsnEdit = true;
    //Taking only number as inputs
     var reg = /^\d+$/;
    var ssnvalue = elem.value.replace(/[*-]/g,'');
     if(!reg.test(ssnvalue )){

        if($scope.driver.value.socialSecurityNumber.length>7){
            var temp=ssnvalue;
            temp=temp.substr(0,temp.length-1);
            ssnvalue = $scope.driver.value.socialSecurityNumber.substr(0,7)+temp;
        }
        else{
            ssnvalue = ssnvalue.substr(0,ssnvalue.length-1); 
        }
        angular.element	(elem).val(String(ssnvalue));
        $scope.$apply();
            return;
     }else{
        if($scope.ssnOriginal[5]){
            $scope.ssnOriginal[5] = ssnvalue;
        }else{

            $scope.ssnOriginal.push(ssnvalue);
        }
     }
    
 //masking first 5 digits of ssn 
     var maskedSSNValue=elem.value.replace(/-/gi,'').replace(/_/gi,'').split('');
     var newMaskedSSNValue=[];
     maskedSSNValue.map( (num,index) =>
         {
       
         if(index<=4){
             if(index == 3 || index  == 5){
 
             newMaskedSSNValue[index]='-*';
             }
             else{
             newMaskedSSNValue[index]='*';
             }
         }
         else 
         {
             if(index ==3 || index==5){
                 newMaskedSSNValue[index]='-' +num;
             }
             else{
                 newMaskedSSNValue[index]= num;
             }
         }
 
 
     });
 

     $scope.driver.socialSecurityNumber = newMaskedSSNValue.join('');
    
    
     if($scope.ssnOriginal.join('').length == 9){
        
             var orgssnvalue = angular.copy($scope.ssnOriginal).join('');
             $scope.driver.value.ssnunMasked=orgssnvalue.substring(0,3) +'-' +orgssnvalue.substring(3,5) + '-' + orgssnvalue.substring(5,9);
            
     }
     
     $scope.$apply();
   
 }
 //SSN INC0019597 


                   
                    let deregisterDriverWatch;
                    let deregisterDobWatch;
                    let deregisterAgeWatch;
                    //let deregisterAssignmentWatch;
                    let deregisterIncludeMCWatch;
                    let deregisterAccidentsInLast3Years;
                    
                     // Current date
                    var currentDate = new Date();
                    
                    // Current local date
                    $scope.currentLocalDate = {
                        year: currentDate.getFullYear(),
                        month: currentDate.getMonth(),
                        day: currentDate.getDate()
                    };
                    
                    $scope.filterNameDetailCodes = {
                        suffix : ["c_II"]
                    }; 
                    
                    // Residence Type Filter Codes
                    $scope.residenceTypeFilterCodes = ["Fam2", "Fam3", "Fam4", "Fam5", "Coop", "Triplex_aaa", "Quadplex_aaa"];
                    
                    // Dont display state codes from this list in license state
                    $scope.stateFilterCodes = ["PR"];
                    
                    // Not display occupation typecodes from this list
                    $scope.occupationFilterCodes = ["studentawaymorethan100mi"];
                    
                    //$scope.addFormErrror = false;
                    //$scope.editFormErrror = false;
                    
                    // Prefill Drivers list
                    $scope.prefillDriversList = [];
                    
                     // Assign driver and vehicle fields
                    function assignDriversToPrefillVehicles (){
                        if($scope.driver.value.oftenDriveVehicle == "principal"){
                            if($scope.driver.value.mostDriveVehicle.prinicipalSelected){
                                //console.log("Another driver is selected as a primary driver for this vehicle.");
                                $scope.driver.value.oftenDriveVehicle = undefined;
                                ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Vehicle Usage Error");
                            }
                            else{
                                $scope.driver.value.mostDriveVehicle.prinicipalSelected = true;
                            }
                        }
                        
                        for(var idx in $scope.vehicles){
                            //console.log("Veh:: ", $scope.vehicles[idx]);
                            if($scope.vehicles[idx]["vin"] == $scope.driver.value.mostDriveVehicle.vin){                                
                                $scope.vehicles[idx]["assignedDriver"] = $scope.driver.value;
                                $scope.vehicles[idx]["driverType"] = $scope.driver.value.oftenDriveVehicle;
                                //console.log("Matched Vehicle:: ", $scope.vehicles[idx]);
                                break;
                            }
                        }
                           
                    };
                    
                    //console.log("jj: ",$scope.accountHolder, $scope.accountHolder.primaryAddress.state);
                                        
                    // Set account holder state for driver
                    //$scope.driver.accountHolderState.value = $scope.accountHolder.primaryAddress.state;
                    
                    // Set license number exists or not
                    $scope.isLicenseNumberExists = ($scope.driver.licenseNumber.value) ? true : false;
                    
                    //console.log("Account Holder State: ",$scope.driver.accountHolderState.value);                         
                                        
                    // reset values
                    $scope.resetValues = function(){

                        return {
                            category : undefined,
                            type : undefined,
                            amount : undefined,
                            date : undefined,
                            waivedStatusStr : undefined,
                            editing : false,
                            remove : false
                        };
                    };
                
                    // Relationhip List
                    $scope.relationShipList = DriverProcessService.getRelationShipList();                  
                    
                    // Set relationship pc mapping 
                    $scope.setRelationShipPcMapping = function(){

                        // PC Mapping - if selected value is Child then map it to Relative
                        if ($scope.driver.relationShipToYou.value == "Child"){
                            $scope.driver.relationShip.value = "Relative";
                        }
                        else{
                            $scope.driver.relationShip.value = $scope.driver.relationShipToYou.value;
                        }
                    };   
                    
                    //$scope.driver.licenseNumber.value = "125899";                    
                    //console.log("driver.licenseNumber.value: ", $scope.driver.licenseNumber, $scope.driver.licenseNumber.value);
                                        
                    // Add New accident voilation model
                    $scope.addAccidentVoilation = $scope.resetValues();
                    
                    // Edit accident voilation model
                    $scope.editAccidentVoilation = $scope.resetValues();
                    
                    // Temp association list
                    $scope.associationList = DriverProcessService.getAssociationList();                  
                    
                     // Usage of vehicle
                    $scope.vehicleUsageList = DriverProcessService.getVehicleUsageList(); 
                    
                    // Accident/ Voilation Category List for add form
                    $scope.addCateogryList = DriverProcessService.getCategoryList();  
                    
                    // Accident/ Voilation Category List for edit form
                    $scope.editCateogryList = DriverProcessService.getCategoryList();
                    
                    // Type Description List for accidents
                    $scope.accidents = DriverProcessService.getAccidentList();
                    
                    // Type description list for claims
                    $scope.claims = DriverProcessService.getClaimList();
                    
                    // Merge accidents and claims
                    //$scope.accidentsClaims = angular.extend($scope.accidents, $scope.claims);
                    
                    // Type Description List for voilations
                    $scope.voilations = DriverProcessService.getVoilationList();                   
                    
                    //console.log("AccidentsClaims: ",$scope.accidentsClaims);
                    //console.log("Voilations: ",$scope.voilations);
                    
                    // hold type list values for add form
                    $scope.addTypeList = {};
                    
                    // Load add type list values
                    $scope.loadAddTypeList = function(){
                        //console.log("Selected Category: ",$scope.addAccidentVoilation.category);
                        if($scope.addAccidentVoilation.category == "accident"){
                            $scope.addTypeList = $scope.accidents;
                        }
                        else if ($scope.addAccidentVoilation.category == "claim"){
                            $scope.addTypeList = $scope.claims;
                        }
                        else if($scope.addAccidentVoilation.category == "voilation"){
                            $scope.addTypeList = $scope.voilations;
                        }
                    };
                    
                    // holds type list values for edit form
                    $scope.editTypeList = {};
                    
                    // Load edit type list values
                    $scope.loadEditTypeList = function(){
                        //console.log("Selected Category: ",$scope.addAccidentVoilation.category);
                        if ($scope.editAccidentVoilation.category == "accident"){
                            $scope.editTypeList = $scope.accidents;
                        }
                        else if ($scope.editAccidentVoilation.category == "claim"){
                            $scope.editTypeList = $scope.claims;
                        }
                        else if ($scope.editAccidentVoilation.category == "voilation"){
                            $scope.editTypeList = $scope.voilations;
                        }
                    };
                    
                    // Load Accident/Claim/Voilation List
                    $scope.loadAccidentVoilationList = function(pcAccidentVoilationList, accountHolderState){
                        
                        if(pcAccidentVoilationList == undefined){
                            pcAccidentVoilationList = [];
                        }
                        
                        //console.log("loadAccidentVoilationList:: ",pcAccidentVoilationList, accountHolderState);
                        return DriverProcessService.mapAccidentListToPortal(pcAccidentVoilationList, accountHolderState);
                    };
                    
                    //console.log("AccidentVoilationList: ",$scope.driver.accidentVoilationList);
                    
                    // Test Code
                    //$scope.driver.accidentVoilationList.value = [{"dateOfEvent":{"year":1987, "month":4, "day":29}, "description":"AFA - PD ONLY >1,800 <3000"}];
                    
                    // accident claim voilation list
                    //$scope.accidentVoilationList = DriverProcessService.mapAccidentListToPortal($scope.driver.accidentVoilationList.value, $scope.driver.accountHolderState.value.code);
                                        
                    // Set accidentsInLast3Years value to true if accidentVoilationList is not empty
                    /*if($scope.accidentVoilationList.length > 0){
                        $scope.driver.accidentsInLast3Years.value = true;
                    }*/
                    
                    // Add accident claim voilations
                    $scope.addAccidentClaimVoilation = function(){ 
                                                                        
                        var accidentVoilation = angular.copy($scope.addAccidentVoilation);
                        
                        $scope.driver.value.isAddAccidentValid = true;
                        
                        if(!accidentVoilation.category || 
                            !accidentVoilation.type || 
                              !accidentVoilation.date){
                           $scope.driver.value.isAddAccidentValid = false;
                           return;
                        }
                        
                        if($scope.driver.accountHolderState.value == 'NC' && accidentVoilation.category != "voilation" && !accidentVoilation.amount){
                            $scope.driver.value.isAddAccidentValid = false;
                            return;
                        }       
                        
                        // check occurence date is a future date
                        var occurenceDate = new Date(accidentVoilation.date.year, accidentVoilation.date.month, accidentVoilation.date.day)
                        var tempDate = new Date();
                        var currentDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate());
                        
                        if (occurenceDate.getTime() > currentDate.getTime()){

                            $scope.driver.value.isAddAccidentValid = false;
                            ModalService.showError('quoteandbind.controllers.ModalService.Attention', "quoteandbind.pa.directives.templates.pa-edit-driver.Future Date Error");
                            return;
                        }
                        
                        // Set edit mode is false by default
                        accidentVoilation.editing = false;
                        $scope.driver.value.accidentVoilationPortalList.push(accidentVoilation);
                        
                        // Reset add form values
                        $scope.addAccidentVoilation = $scope.resetValues();
                        
                        $scope.addTypeList = {};
                        
                        var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.driver.value.accidentVoilationPortalList, $scope.driver.accountHolderState.value.code);
                        $scope.driver.value.accidentVoilationList = pcAccidentList;
                    };
                    
                    // display edit form
                    $scope.displayEditForm = false;
                    
                    // Current item idx is on edit mode
                    $scope.editIndex = -1;
                    
                    // Edit accident voilation item
                    $scope.editAccidentVoilationItem = function(idx){                    
                        
                        $scope.displayEditForm = true;                                                                  
                        
                        $scope.editIndex = idx;//_.findLastIndex($scope.accidentVoilationList, accidentVoilation);
                        //console.log("Index1: ", idx, $scope.editIndex);
                        var accidentVoilation = $scope.accidentVoilationList[idx];
                        resetEditFlag(accidentVoilation); 
                        //$scope.editAccidentVoilation = accidentVoilation;
                        $scope.editAccidentVoilation = angular.copy(accidentVoilation);
                        // Load edit type list values
                        $scope.loadEditTypeList();
                    };                   
                    
                    // Reset edit flag for other than passed input 
                    // on the $scope.accidentVoilationList 
                    function resetEditFlag(accidentVoilation){
                        for( var idx in $scope.accidentVoilationList ){
                            if($scope.accidentVoilationList[idx] === accidentVoilation){
                                $scope.accidentVoilationList[idx]["editing"] = true;
                            }
                            else{
                                $scope.accidentVoilationList[idx]["editing"] = false;
                            }
                        }
                    };
                    
                    // Update accident claim voilation item
                    $scope.updateAccidentClaimVoilation = function(idx){
                                 
                        // Currently editing item
                        var accidentVoilation = $scope.accidentVoilationList[idx];
                        
                        // Edit data
                        var editCopy = angular.copy($scope.editAccidentVoilation);
                        
                        $scope.driver.value.isEditAccidentValid = true;
                        
                        if (!editCopy.category ||
                             !editCopy.type ||
                              !editCopy.date){
                            $scope.driver.value.isEditAccidentValid = false;
                            return;
                        }

                        if (editCopy.category != "voilation" && !editCopy.amount){
                            $scope.driver.value.isEditAccidentValid = false;
                            return;
                        }
                        accidentVoilation["editing"] = false;
                        accidentVoilation["category"] = editCopy.category;
                        accidentVoilation["type"] = editCopy.type;
                        accidentVoilation["amount"] = editCopy.amount;
                        accidentVoilation["date"] = editCopy.date; 
                        accidentVoilation["pcDescription"] = editCopy.description                      
                                                
                        // Reset edit form values
                        $scope.editAccidentVoilation = $scope.resetValues();
                        $scope.displayEditForm = false;
                        
                        var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.accidentVoilationList, $scope.driver.accountHolderState.value.code);
                        $scope.driver.accidentVoilationList.value = pcAccidentList;
                        //console.log("$scope.driver.accidentVoilationList: ", $scope.driver.accidentVoilationList.value);
                    };
                    
                    // Delete accident claim voilation item
                    $scope.deleteAccidentClaimVoilation = function(idx){
                        
                        $scope.driver.value.accidentVoilationPortalList[idx]["editing"] = false;
                        
                        var accidentVoilation = $scope.driver.value.accidentVoilationPortalList[idx];
                        var deleteVoilation = angular.copy(accidentVoilation);
                        
                        // Initialize delete accident voilation list
                        if ($scope.driver.value.deleteViolationList == null ||
                                $scope.driver.value.deleteViolationList == undefined){
                            $scope.driver.value.deleteViolationList = [];
                        }

                        // Add deleted accident voilation into the deletion list to
                        // deleted the initial disclosures from driver entity
                        if (deleteVoilation.publicID){
                            $scope.driver.value.deleteViolationList.push(deleteVoilation);
                        }
                        
                        $scope.driver.value.accidentVoilationPortalList = _.without($scope.driver.value.accidentVoilationPortalList, _.findWhere($scope.driver.value.accidentVoilationPortalList, accidentVoilation));
                        
                        $scope.displayEditForm = false;
                        //console.log("DeleteAccidentClaimVoilation.List: ", $scope.accidentVoilationList, accidentVoilation);
                        
                        var pcAccidentList = DriverProcessService.mapAccidentListToPC($scope.driver.value.accidentVoilationPortalList, $scope.driver.accountHolderState.value.code);
                        $scope.driver.value.accidentVoilationList = pcAccidentList;
                        //console.log("Delete AccidentVoilationList: ", $scope.driver.value.accidentVoilationList);
                    };
                    
                    // Display Type 
                    $scope.displayItemType = function(item){
                       
                        /*if(item.category == "accident"){
                            return $scope.accidents[item.type];
                        }
                        else if(item.category == "voilation"){
                            return $scope.voilations[item.type];
                        }
                        else if (item.category == "claim"){
                            return $scope.claims[item.type];
                        }
                        
                        return "N/A";*/
                        if(item.category == "voilation" && item.pcDescription =="DWI")
                        {
                           return "major violation";
                        }
                        else if(item.category == "voilation" && (item.pcDescription == undefined || item.pcDescription == "FAIL TO REDUCE SPEED")){
                            return "moving violation";
                        }
                        else
                        {
                            if(item.pcDescription == null || item.pcDescription == undefined){
                            return item.description;
                        } else {
                            return item.pcDescription;
                        }
                        }
                    };
                    
                    // Display amount in gw currency format
                    $scope.displayAmount = function(item){
                        return  item.amount;
                    };
                    
                    // Display date in MM/DD/YYYY format
                    $scope.displayDate = function(item){
                        
                        var date = new Date(item.date.year, item.date.month, item.date.day, 0, 0, 0);
                                                
                        return moment(date.toJSON()).format("MM/DD/YYYY");
                    }; 
                   

                    function resetForm() {               
                         
                        if(angular.isDefined($scope.driver.value)){
                            
                            // Set prefill vehicle count
                            $scope.driver.value.prefillVehicleCount = $scope.prefillVehicles.length;
                            $scope.driver.prefillVehicleCount.value = $scope.prefillVehicles.length;
                            
                            //console.log("Hello: ",$scope.prefillVehicles, $scope.driver.value.prefillVehicleCount);
                            
                            $scope.driver.value.accidentVoilationPortalList = DriverProcessService.mapAccidentListToPortal($scope.driver.value.accidentVoilationList, $scope.driver.accountHolderState.value.code);
                        }    
                        //reset ssn original
                        $scope.ssnOriginal = [];
						$scope.isSsnEdit = false;

                        //console.log("Hello1: ",$scope.driver.value);
                        
                        const startingYear = new Date();

                        $scope.editableDriverDOB = editableDriverDOB;
                        $scope.maxDateOfBirth = {
                            year: startingYear.getFullYear() - AgeAllowedToDrive,
                            month: startingYear.getMonth(),
                            day: startingYear.getDate()
                        };
                        
                        // Driver max date of birth
                        $scope.maxDriverDateOfBirth = {
                            year: startingYear.getFullYear() - LicensedAgeAllowedToDrive,
                            month: startingYear.getMonth(),
                            day: startingYear.getDate()
                        };

                        $scope.years = [];
                        const currentYear = new Date().getUTCFullYear();

                        $scope.setYears = (earliestYear)=> {
                            $scope.years.length = 0;
                            for (let i = currentYear - earliestYear; i <= currentYear; i++) {
                                $scope.years.unshift(i);
                                if (i === currentYear) {
                                    //last iteration of loop, if user has changed their dob to be after year first licensed
                                    //make sure that the yearLicensed previously chosen is still valid.
                                    if ($scope.driver.value && $scope.driver.yearLicensed.value &&
                                        $scope.years.indexOf($scope.driver.yearLicensed.value) === -1) {
                                        $scope.driver.yearLicensed.value = undefined;
                                    }
                                }
                            }
                        };
                        
                        $scope.updateDriverExperience = (dateOfBirth, firstLicensed) => {

                            if (dateOfBirth && firstLicensed){

                                var driverExperience = DriverProcessService.getDriverExperience(dateOfBirth, firstLicensed);
                                //console.log("inExperiencedDriver:::: ", $scope.driver.inExperiencedDriver);
                                if (driverExperience < 3){
                                    $scope.driver.inExperiencedDriver.value = true;
                                }
                                else{
                                    $scope.driver.inExperiencedDriver.value = false;
                                }

                                // Update Year First Licensed
                                $scope.driver.yearLicensed.value = DriverProcessService.calcYearFirstLicensed(dateOfBirth, firstLicensed);
                            }
                        };

                        if ($scope.driver.value && $scope.driver.dateOfBirth.value) {
                            const dobDate = $scope.driver.dateOfBirth.value;
                            $scope.setYears(currentYear - (dobDate.year + AgeAllowedToDrive));
                        } else {
                            $scope.setYears(AgeAllowedToDrive);
                        }   

                        deregisterDobWatch = $scope.$watch('driver.dateOfBirth.value', (dob)=> {
                            if (angular.isDefined(dob)) {
                                $scope.setYears(currentYear - (dob.year + AgeAllowedToDrive));
                                //updateDriverExperience(dob, $scope.driver.firstLicensed.value); 
                                $scope.updateDriverExperience(dob, $scope.driver.firstLicensed.value);
                                $scope.age= $scope.getAge(dob); //added age *Princy UI
                                if(dob){
                                    $scope.checkDate();
                                }
                            }
                        }, true);
                        
                        deregisterAgeWatch = $scope.$watch('driver.firstLicensed.value', (ageFirstLicensed) => {
                            if (angular.isDefined(ageFirstLicensed)) {
                                //updateDriverExperience($scope.driver.dateOfBirth.value, ageFirstLicensed);
                                $scope.updateDriverExperience($scope.driver.dateOfBirth.value, ageFirstLicensed);
                            }
                        }, true);

                        deregisterDriverWatch = $scope.$watch('driver.value', ()=> {
                            if (angular.isDefined($scope.driver.value)) {
                                //devendra commented below line
                                $scope.fixedDateOfBirth = LocalDateUtil.toMidnightDate($scope.driver.dateOfBirth.value);
                                $scope.driver.accidents.value = $scope.driver.accidents.value || $scope.driver.accidents.aspects.availableValues[0];
                                $scope.driver.violations.value = $scope.driver.violations.value || $scope.driver.violations.aspects.availableValues[0];
                                
                                $scope.driver.value.accidentVoilationPortalList = DriverProcessService.mapAccidentListToPortal($scope.driver.value.accidentVoilationList, $scope.driver.accountHolderState.value.code);
                                
                                // Reset add accident selection when switch on drivers
                                $scope.addAccidentVoilation = $scope.resetValues();
                            }
                        });
                        
                        /*deregisterAssignmentWatch = $scope.$watch('driver.oftenDriveVehicle.value', () => {
                            if (angular.isDefined($scope.driver.oftenDriveVehicle.value)) {
                                //assignDriversToPrefillVehicles();
                            }
                        });*/
                        
                        deregisterIncludeMCWatch = $scope.$watch('driver.inMotorCycle.value', (inMotorCycle) => {
                            if(inMotorCycle == false){
                                
                                if($scope.driver.takenMotorSafetyCourse.value == true){
                                    $scope.driver.takenMotorSafetyCourse.value = undefined;
                                }
                                
                                if ($scope.driver.endorsementOnDriverLicense.value == true){
                                    $scope.driver.endorsementOnDriverLicense.value = undefined;
                                }
                            $scope.driver.motorCycleSafetyCourseYear.value = undefined;
                            }
                        });

                        deregisterIncludeMcDateWatch = $scope.$watch('driver.takenMotorSafetyCourse.value', () => {

                                if(!$scope.driver.takenMotorSafetyCourse.value){
                                     $scope.driver.motorCycleSafetyCourseYear.value = undefined;
                                }
                         });
                         
                        // Delete incidents if selected value for  accidentsInLast3Years is false
                        deregisterAccidentsInLast3Years = $scope.$watch('driver.accidentsInLast3Years.value', () => {

                            if ($scope.driver.accidentsInLast3Years.value != undefined && 
                                    $scope.driver.accidentsInLast3Years.value == false){
                                
                                var accidentVoilations = angular.copy($scope.driver.value.accidentVoilationPortalList);
                                            
                                // Initialize delete accident voilation list
                                if ($scope.driver.value.deleteViolationList == null ||
                                        $scope.driver.value.deleteViolationList == undefined){
                                    $scope.driver.value.deleteViolationList = [];
                                }
                                
                                for(var idx in accidentVoilations){
                                    
                                     var deleteVoilation = accidentVoilations[idx];
                                    
                                    // Add deleted accident voilation into the deletion list to
                                    // deleted the initial disclosures from driver entity
                                    if (deleteVoilation.publicID){
                                        $scope.driver.value.deleteViolationList.push(deleteVoilation);
                                    }
                                }    
                                
                                $scope.driver.value.accidentVoilationPortalList = [];
                                $scope.driver.value.accidentVoilationList = [];
                                
                            }
                        });
                    }

                    resetForm();
                    $scope.$on('update-form', ()=> {
                        deregisterDriverWatch();
                        deregisterDobWatch();
                        deregisterAgeWatch();
                        //deregisterAssignmentWatch();
                        deregisterIncludeMCWatch();
                        deregisterAccidentsInLast3Years();
                        resetForm();
                    });
                                     
                }]
            
            };
        }];
    });



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/pa/directives/PAEditDriver.js
 **/